import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import { Avatar, Divider, InlineBlock, List, Popover } from "reakit";
import { Box, Button as RButton, Flex, Heading, Image, Text } from "rebass";
import Badge from "@material-ui/core/Badge";
import {
  ChatActive,
  ChatInactive,
  Home,
  HomeInactive,
  LeavesActive,
  LeavesInactive,
  CalendarActive,
  CalendarInactive,
  NoAvatar,
} from "../Base/Icons";
// icon imports
import SearchInput from "./SearchInput";
import WaveDropdown from "../Wave/WaveDropdown";
import {
  DesktopWrapper,
  MobileWrapper,
  NavLink as Link,
  PositionBox,
  Toolbar,
} from "../Base";
import SidebarMenu from "../Sidebar";
import SignOutButton from "./SignOutButton";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";
import logo from "../../resources/img/logo-192x192.png";
// import {connect} from 'react-redux'

const PopoverMenu = styled(Popover)`
  width: 25vw;
  overflow: hidden;
`;

const BadgeText = styled(Text)`
  padding-right: 5px;
  display: inline-block;
`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      open: false,
      // isFaculty: false,
      searchTerm: "",
      unreadMessageCount: 0,
    };
  }

  componentDidMount() {
    const { loginFailed, history } = this.props;
    if (loginFailed) {
      history.replace("/app");
      history.push("/app");
    }
    /**
     * Open Listenr for fetching Unread Message Count
     */
    this.fetchUnreadMessageListener = this.fetchUnreadMessage();
  }

  componentWillUnmount() {
    this.fetchUnreadMessageListener();
  }

  fetchUnreadMessage = () => {
    const { profile } = this.props;
    let unreadMessageCount;
    return this.props.firebase.chats().onSnapshot((snapshot) => {
      unreadMessageCount = 0;
      snapshot.forEach((doc) => {
        let { messages, members } = doc.data();
        if (messages && messages.length > 0 && members.includes(profile.id)) {
          for (let i in messages) {
            if (!messages[i].seen.includes(profile.id)) {
              unreadMessageCount++;
            }
          }
        }
      });
      this.setState({ unreadMessageCount });
    });
  };

  toggleMenuBar(e) {
    const { open } = this.state;
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.setState({
      open: !open,
    });
  }

  handleGoBack = () => {
    const { history } = this.props;
    if (history) {
      history.goBack();
    }
  };

  closeMenuBar() {
    this.setState({ open: false });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const { history } = this.props;
    history.push("/app/search");
  };

  handleSearchInput = (e) => {
    e.preventDefault();
    this.setState({ searchTerm: e.target.value });
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.search !== this.props.search) {
      return false;
    }
    return true;
  }

  render() {
    // const {open, isFaculty} = this.state;
    const footerPadding = 40;
    // const { , loading} = this.state;
    const {
      location,
      profile,
      noSideBar,
      rosterDetails,
      noFooter,
      isFaculty,
      bg,
      school,
      postTitle,
      title,
      noHeader,
      details,
    } = this.props;
    let iconColor = "black";
    let headerColor = bg;
    if (details) {
      if (
        details.status === 0 ||
        (details.status > 3 && details.status < 7) ||
        (!details.parent_host && details.status === 7) ||
        (details.status > 7 && details.status < 10)
      ) {
        headerColor = "yellow";
        iconColor = "white";
      }
      if (details.status > 0 && details.status < 4) {
        headerColor = "red";
        iconColor = "white";
      }
      if ((details.parent_host && details.status === 7) || details.status > 9) {
        headerColor = "green";
        iconColor = "white";
      }

      if (headerColor !== "white") {
        iconColor = "white";
      }
    }

    let roster = { name: "", students_uid: [] };

    let count = 0;
    if (rosterDetails === true) {
      if (this.props.roster != null) {
        roster = this.props.roster;

        if (roster && roster.students_uid) {
          count = roster.students_uid.length;
        }
      }
    }
    let showCheckin = false;
    if (isFaculty) {
      showCheckin = true;
    }
    if (!isFaculty && profile && profile.is_prefect) {
      showCheckin = true;
    }

    const { unreadMessageCount } = this.state;
    return (
      <Box>
        <DesktopWrapper width={1}>
          <Flex width={1} flexDirection={"column"}>
            <Toolbar
              p={2}
              width={1}
              height={"100px"}
              bg="gray"
              flexWrap="wrap"
              flexDiretion="row"
              /*position={['relative']}*/ top={0}
            >
              <Image
                src={logo}
                alignSelf={"center"}
                height={"48px"}
                borderRadius={4}
                ml={"12px"}
              />
              {profile !== null && (
                <Box ml={3} width={1 / 2} p={2}>
                  {isFaculty ? (
                    <SearchInput />
                  ) : (
                    <WaveDropdown
                      isFaculty={isFaculty}
                      student={profile}
                      profile={profile}
                      school={school}
                    />
                  )}
                </Box>
              )}
              <Box ml="auto" />
              <Link
                mt={isFaculty ? 0 : 1}
                className="nav-link"
                to="/app/home"
                onClick={() => this.closeMenuBar()}
              >
                Home
              </Link>
              <Link
                mt={isFaculty ? 0 : 1}
                to="/app/leaves"
                onClick={() => this.closeMenuBar()}
              >
                Leaves
              </Link>
              {/* <Link
                mt={isFaculty ? 0 : 1}
                to="/app/health"
                onClick={() => this.closeMenuBar()}
              >
                Health
              </Link> */}
              <Link
                mt={isFaculty ? 0 : 1}
                to="/app/chat"
                onClick={() => this.closeMenuBar()}
              >
                <Badge
                  style={{ marginTop: "-0.2em" }}
                  badgeContent={unreadMessageCount}
                  color="primary"
                >
                  <BadgeText>Chats</BadgeText>
                </Badge>
              </Link>

              <Link
                mt={isFaculty ? 0 : 1}
                to="/app/calendar"
                onClick={() => this.closeMenuBar()}
              >
                Calendar
              </Link>

              <Box py={2} mt={isFaculty ? 1 : 2} ml={2}>
                <Popover.Container>
                  {(popover) => (
                    <InlineBlock relative>
                      <Box onClick={popover.toggle} {...popover}>
                        {profile === null ? (
                          <NoAvatar />
                        ) : (
                          <Avatar
                            src={profile.profile_pic}
                            height={"30px"}
                            width={"30px"}
                          />
                        )}
                      </Box>
                      <PopoverMenu
                        fade
                        slide
                        expand
                        hideOnClickOutside
                        {...popover}
                      >
                        <List>
                          <li>
                            <Link
                              color="black"
                              className="nav-link"
                              to="/app/profile"
                              onClick={popover.hide}
                            >
                              My Profile
                            </Link>
                          </li>
                          <Divider margin={0} />
                          <li>
                            <Link
                              color="black"
                              to="/app/posts"
                              onClick={popover.hide}
                            >
                              My Posts
                            </Link>
                          </li>
                          <Divider margin={0} />
                          {/* {profile.is_health_admin && (
                            <li>
                              <Link
                                color="black"
                                to="/app/health-admin"
                                onClick={popover.hide}
                              >
                                Health (Admin)
                              </Link>
                            </li>
                          )} */}
                          <Divider margin={0} />
                          {/* {isFaculty &&
													<Fragment>

														<li>

															<Link color='black' to="/app/roster" onClick={() => this.closeMenuBar()}>
																My Rosters
															</Link>
														</li>
														<Divider margin={0}/>

													</Fragment>
													} */}
                          {!isFaculty &&
                            profile &&
                            profile.is_prefect === true && (
                              <Fragment>
                                <li>
                                  <Link
                                    color="black"
                                    to="/app/dorm"
                                    onClick={popover.hide}
                                  >
                                    My Dorm
                                  </Link>
                                </li>
                                <Divider margin={0} />
                              </Fragment>
                            )}

                          {showCheckin && (
                            <Fragment>
                              <li>
                                <Link
                                  color="black"
                                  to="/app/checkin"
                                  onClick={popover.hide}
                                >
                                  Check In
                                </Link>
                              </li>
                              <Divider margin={0} />
                            </Fragment>
                          )}

                          {/** <li>
                            <Link
                              color="black"
                              to="/app/calendar"
                              onClick={popover.hide}
                            >
                              Calendar
                            </Link>
                          </li>
                          <Divider margin={0} /> */}
                          <li>
                            <Link
                              color="black"
                              to="/app/search-faculty"
                              onClick={popover.hide}
                            >
                              Search Faculty
                            </Link>
                          </li>
                          {isFaculty && profile.is_admin && (
                            <Divider margin={0} />
                          )}
                          {isFaculty && profile.is_admin && (
                            <li>
                              <Link
                                color="black"
                                to="/app/settings"
                                onClick={popover.hide}
                              >
                                Settings
                              </Link>
                            </li>
                          )}
                          <Divider margin={0} />
                          <li>
                            <SignOutButton />
                          </li>
                          <Divider margin={0} />
                        </List>
                      </PopoverMenu>
                    </InlineBlock>
                  )}
                </Popover.Container>
              </Box>

              {rosterDetails && (
                <Box width={1} p={4}>
                  <Flex width={1} flexDirection={"row"}>
                    <Box>
                      <RButton
                        onClick={this.handleGoBack}
                        p={3}
                        borderRadius={"50px"}
                        bg={"white"}
                        color={"gray"}
                      >
                        {" "}
                        <IosArrowBack color={"gray"} />{" "}
                      </RButton>
                    </Box>
                    <Box ml={3}>
                      <Heading color={"white"}>
                        {roster.name} ({count})
                      </Heading>
                    </Box>
                  </Flex>
                </Box>
              )}
            </Toolbar>
          </Flex>
        </DesktopWrapper>
        {/* DESKTOP ENDS HERE*/}

        {/*---------------------------------*/}

        {/* MOBILE STARTS HERE*/}
        <MobileWrapper>
          <Toolbar
            zIndex={9000}
            width={1}
            bg={headerColor}
            justifyContent="left"
            position={["fixed"]}
            top={0}
          >
            {!noHeader && noSideBar && (
              <Box ml={0} height={"30px"} width={"30px"}>
                <IosArrowBack
                  onClick={this.handleGoBack}
                  style={{ paddingLeft: "16px", paddingTop: "16px" }}
                  color={iconColor}
                  fontSize="30px"
                />
              </Box>
            )}

            {!noSideBar && profile && (
              <SidebarMenu
                school={school}
                isFaculty={isFaculty}
                profile={profile}
              />
            )}

            {postTitle && (
              <PositionBox
                position={"relative"}
                bottom={"-25px"}
                width={0.85}
                zIndex={8900}
              >
                <Flex width={1} justifyContent={"center"}>
                  <Text fontWeight={600} color={"meta"}>
                    {title}
                  </Text>
                </Flex>
              </PositionBox>
            )}
          </Toolbar>

          {!noFooter && (
            <Toolbar
              width={1}
              height={"100px"}
              bg="gray"
              flexWrap="wrap"
              flexDiretion="row"
              justifyContent="center"
              position={["fixed"]}
              bottom={0}
            >
              <Link py={12} to="/app/home">
                {location && location.pathname === "/app/home" ? (
                  <Home />
                ) : (
                  <HomeInactive />
                )}
              </Link>
              <Link py={12} to="/app/leaves">
                {location && location.pathname === "/app/leaves" ? (
                  <LeavesActive />
                ) : (
                  <LeavesInactive />
                )}
              </Link>
              <Link py={12} to="/app/chat">
                <Badge badgeContent={unreadMessageCount} color="primary">
                  {location && location.pathname === "/app/chat" ? (
                    <ChatActive />
                  ) : (
                    <ChatInactive />
                  )}
                </Badge>
              </Link>
              <Link py={12} to="/app/calendar">
                {location && location.pathname === "/app/calendar" ? (
                  <CalendarActive />
                ) : (
                  <CalendarInactive />
                )}
              </Link>
            </Toolbar>
          )}
        </MobileWrapper>
      </Box>
    );
  }
}

Header.propTypes = {
  noSideBar: PropTypes.bool,
  noFooter: PropTypes.bool,
  rosterDetails: PropTypes.bool,
  isFaculty: PropTypes.bool,
  profile: PropTypes.object,
  bg: PropTypes.string,
  details: PropTypes.object,
};

Header.defaultProps = {
  noSideBar: false,
  noFooter: false,
  rosterDetails: false,
  bg: "white",
};

export default withRouter(Header);
